import { render, staticRenderFns } from "./m2m.vue?vue&type=template&id=2d69e5e6&scoped=true&"
import script from "./m2m.vue?vue&type=script&lang=js&"
export * from "./m2m.vue?vue&type=script&lang=js&"
import style0 from "../common.css?vue&type=style&index=0&id=2d69e5e6&scoped=true&lang=css&"
import style1 from "./m2m.vue?vue&type=style&index=1&id=2d69e5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d69e5e6",
  null
  
)

export default component.exports